import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import About from './components/About.vue'
import Contacts from './components/Contact.vue'
import AllProjects from './components/AllProjects.vue'
import Project from './components/Project.vue'
import AllPeople from './components/AllPeople.vue'
import AllPublications from './components/AllPublications.vue'
import Publication from './components/Publication.vue'
import Bibtex from './components/Bibtex.vue'
import AllCourses from './components/AllCourses.vue'
import Openings from './components/Openings.vue'
import NavShell from './components/NavShell.vue'

Vue.use(Router)
console.log('base:' + process.env.BASE_URL)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'navshell',
      component: NavShell,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home
        },
        {
          path: '/home',
          name: 'home',
          component: Home
        },
        {
          path: '/about',
          name: 'about',
          component: About
        },
        {
          path: '/contact',
          name: 'contact',
          component: Contacts
        },
        {
          path: '/projects',
          name: 'projects',
          component: AllProjects
        },
        {
          path: '/publications',
          name: 'publications',
          component: AllPublications
        },
        {
          path: '/project/:slug',
          name: 'project',
          component: Project
        },
        {
          path: '/people',
          name: 'people',
          component: AllPeople
        },
        {
          path: '/courses',
          name: 'courses',
          component: AllCourses
        },
        {
          path: '/openings',
          name: 'openings',
          component: Openings
        }]
    },
    {
      path: '/publication/:slug',
      name: 'publication',
      component: Publication
    },
    {
      path: '/bibtex/:data',
      name: 'bibtex',
      props: true,
      component: Bibtex
    }]
})
